module.exports = "/_next/static/images/easy-asset-3836454b721c07c2a593aae91a3206c8.png";